import { ApiProvider } from '../types/ApiProvider';

export const SocietyAiAgentPageInitValue = {
  data: {
    inputText: '',
    selectedApi: 'anthropic' as ApiProvider,
    apiOptions: [],
    messages: [],
    isThinking: false,
    streamingText: '',
    conversations: [],
    activeConversationId: null,
  },
  actions: {
    handleChangeInputText: () => {},
    handleChangeSelectedApi: () => {},
    handleResetConversation: () => {},
    handleSelectConversation: () => {},
    handleSendMessage: () => {},
  },
};
